import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import ListDisciplines from "./List";
import { DISCIPLINES, AdministrationServicePath } from "utils/constants";
import EditDisciplines from "./Edit";
import CreateDisciplines from "./Create";
import permissions from "app/permissions";
import ShowDisciplines from "./Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <AutoStoriesIcon />,
  name: AdministrationServicePath + DISCIPLINES,
  title: "Дисциплини",
  list: <ListDisciplines />,
  create: <CreateDisciplines />,
  createPermission: permissions.canCreateDisciplines,
  edit: <EditDisciplines />,
  show: <ShowDisciplines />,
  editPermission: permissions.canUpdateDisciplines,
  permission: permissions.canPreviewDisciplines,
};
